// CSV cell escaping with formula-injection guard. A cell beginning with
// `=`, `+`, `-`, `@`, tab, or CR can trigger formula execution in Excel /
// Google Sheets when the CSV is opened; prefix those with a single quote.

const FORMULA_TRIGGER = /^[=+\-@\t\r]/;
const NEEDS_QUOTING = /[",\n\r]/;

export function csvEscape(v: unknown): string {
  const raw = v === null || v === undefined ? '' : String(v);
  const safe = FORMULA_TRIGGER.test(raw) ? `'${raw}` : raw;
  return NEEDS_QUOTING.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export function toCsv(headers: readonly string[], rows: readonly Record<string, unknown>[]): string {
  const headerLine = headers.map(csvEscape).join(',');
  const dataLines = rows.map((r) => headers.map((h) => csvEscape(r[h])).join(','));
  return [headerLine, ...dataLines].join('\n');
}
